import { SVGProps } from 'react';

const Clutch = ({
  props,
  fill,
  secondaryFill,
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  secondaryFill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill || '#fff'}
      fillRule="evenodd"
      d="M12.31 3.01c-.092.013-.396.051-.675.086-1.478.182-2.833.716-4.164 1.64-.454.315-1.455 1.326-1.794 1.81-1.698 2.428-2.139 5.615-1.175 8.491a8.767 8.767 0 0 0 4.01 4.861c.797.45 1.942.843 2.983 1.025.664.116 2.599.098 3.292-.03 1.827-.34 3.4-1.146 4.755-2.44l.458-.436-1.408-1.406c-.775-.773-1.433-1.405-1.462-1.405-.028 0-.256.174-.506.386-.249.213-.539.445-.643.516-2.032 1.38-4.86 1.146-6.52-.539-.943-.956-1.41-2.146-1.41-3.596 0-1.03.217-1.861.692-2.653.754-1.256 2.019-2.039 3.619-2.24 1.59-.2 3.012.254 4.327 1.382.242.207.45.367.462.355.444-.408 2.786-2.789 2.786-2.832 0-.087-.804-.806-1.409-1.26-.539-.404-1.624-.98-2.277-1.208-.966-.337-1.781-.48-2.899-.508-.48-.012-.948-.012-1.041.001Z"
      clipRule="evenodd"
    />
    <path
      fill={secondaryFill || '#ff3c2e'}
      d="M10.795 9.968c.502-.522 1.095-.836 1.77-.939.862-.13 1.899.185 2.536.77.273.252.566.688.735 1.095.15.358.162.446.164 1.086.002.782-.075 1.094-.392 1.588-.421.656-.982 1.09-1.7 1.314-.467.146-1.243.158-1.698.026a3.026 3.026 0 0 1-2.157-3.492c.078-.419.448-1.142.742-1.448Z"
    />
  </svg>
);

export default Clutch;
